module.exports = __webpack_public_path__ + "img/my_profile.5784dc01.svg";